module.exports = __webpack_public_path__ + "img/gs.0972fe87.png";